import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { Avatar, Badge, Drawer } from 'antd';
import Bellicon from '../../../assets/Bellicon.jsx';
import MobileBottomBar from '../mobileBottomBar/MobileBottomBar.jsx';
import AppSidebar from '../sidebar/Sidebar.jsx';
import Notifications from '../notifications/Notifications.jsx';
import { GetNotificationApi, ClearNotificationApi } from '../../../api/request/users.js';
import { getEnv } from '../../../utils/utils.js';

const name = getEnv("REACT_APP_NAME", "CapitalFxGlobal");

export default function MobileLayout({ children, ib, title = name }) {
    const { userDetails } = useSelector(state => state.user);
    const location = useLocation();
    const navigate = useNavigate();
    // const { callAddTicketHandler, hasHandler } = useSupportContext();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [notifications, setNotifications] = useState({ isReadCount: 0, unReadCount: 0, totalMessageCount: 0, details: [] });

    // Check if current page is dashboard
    const isDashboard = location.pathname === '/dashboard' || location.pathname === '/ib/dashboard';
    const showBackButton = !isDashboard && title !== "CapitalFxGlobal";

    const getNotification = async () => {
        try {
            const { data } = await GetNotificationApi();
            if (data?.success) {
                setNotifications(data?.data);
            }
        } catch (error) { }
    };

    const clearNotifications = async () => {
        try {
            const { data } = await ClearNotificationApi();
            if (data.success) {
                setNotifications({ isReadCount: 0, unReadCount: 0, totalMessageCount: 0, details: [] });
                toast.success(data.message);
            }
        } catch (error) { }
    };

    React.useEffect(() => {
        getNotification();
    }, []);

    React.useEffect(() => {
        setIsDrawerOpen(false);
    }, [location]);

    return (
        <div className="mobile-layout min-h-screen bg-[#F1F5F9]">
            {/* Mobile Header */}
            {showBackButton ? (
                // Back button header for non-dashboard pages
                <div className="bg-white shadow-sm border-b border-gray-200 px-4 py-3 flex items-center sticky top-0 z-40 justify-between">
                    <div className='flex items-center'>
                        <button
                            onClick={() => navigate(-1)}
                            className="p-2 rounded-lg hover:bg-gray-100 transition-colors mr-3"
                        >
                            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>
                        <h1 className="text-lg font-semibold primary capitalize">{location.state?.title || title}</h1>
                    </div>
                </div>
            ) : (
                // Regular header for dashboard
                <div className="bg-white shadow-sm border-b border-gray-200 px-4 py-3 flex items-center justify-between sticky top-0 z-40">
                    {/* Left side - Menu and Logo */}
                    <div className="flex items-center space-x-3">
                        {/* <button
                            onClick={() => setIsDrawerOpen(true)}
                            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                        >
                            <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button> */}
                        <img className="h-8" src="/assets/logo/logo.png" alt="logo" />
                    </div>

                    {/* Right side - Notifications and Profile */}
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={() => setIsNotificationOpen(true)}
                            className="p-2 rounded-lg hover:bg-gray-100 transition-colors relative"
                        >
                            <Badge count={notifications?.unReadCount || 0} overflowCount={5}>
                                <Bellicon />
                            </Badge>
                        </button>
                        <button
                            onClick={() => navigate('/profile')}
                            className="p-1 rounded-lg hover:bg-gray-100 transition-colors"
                        >
                            <Avatar
                                size={32}
                                className="uppercase bg-blue-500"
                                src={userDetails?.profileImage}
                            >
                                {userDetails?.firstName?.charAt(0)}{userDetails?.lastName?.charAt(0)}
                            </Avatar>
                        </button>
                    </div>
                </div>
            )}

            {/* Main Content */}
            <div className="px-4 py-4 pb-40">
                {children}
            </div>

            {/* Mobile Bottom Navigation */}
            <MobileBottomBar ib={ib} />

            {/* Sidebar Drawer */}
            <Drawer
                open={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                className="top-0 left-0 h-full w-full z-50"
                width={280}
                placement="left"
                styles={{
                    body: { padding: 0 }
                }}
            >
                <AppSidebar ib={ib} />
            </Drawer>

            {/* Notification Drawer */}
            <Drawer
                title={
                    <div className="flex justify-between items-center">
                        <p>Notifications</p>
                        <button
                            className="text-blue-500 text-sm font-medium"
                            onClick={clearNotifications}
                        >
                            Clear all
                        </button>
                    </div>
                }
                onClose={() => setIsNotificationOpen(false)}
                width={"100%"}
                open={isNotificationOpen}
                className='!bg-[#F1F5F9]'
            >
                <Notifications notifications={notifications} getNotification={getNotification} />
            </Drawer>
        </div>
    );
}